import {useQuery} from "react-query";
import api from "../api";

export const useGetMarketPlace = () => {
    return useQuery(["marketplace"], () => {
        return api.get("/market-stage").then((res) => res.data);
    });
}